module.exports = __webpack_public_path__ + "static/media/Merriweather-Black.bfc959a1.ttf";